import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable native select component
 * @param {object} props - props object
 * @param {array} props.options - array of options
 * @param {string} props.value - value of select
 * @param {function} props.onChange - function to be called when select value is changed
 * @param {object} props.selectRestAttribute - rest of the attributes for select
 * @returns {element} - select
 */
const NativeSelect = forwardRef(
	(
		{
			options,
			onChange,
			placeholderText,
			defaultValue,
			...selectrestattribute
		},
		ref,
	) => {
		return (
			<select
				onChange={onChange}
				{...selectrestattribute}
				ref={ref}
				defaultValue={defaultValue}
			>
				<option value=''>{placeholderText}</option>
				{options.map(({ label, value }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
		);
	},
);

NativeSelect.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	onChange: PropTypes.func.isRequired,
	selectrestattribute: PropTypes.object,
	placeholderText: PropTypes.string.isRequired,
	defaultValue: PropTypes.string,
};

// NativeSelect.defaultProps = {
// 	selectrestattribute: {},
// 	defaultValue: '',
// };

export default NativeSelect;
